import React, { useEffect, useState } from 'react';
import { cn } from '../../lib/utils';
interface MoveTimerProps {
  seconds: number;
  totalSeconds?: number;
  isActive?: boolean;
}
export function MoveTimer({
  seconds,
  totalSeconds = 30,
  isActive = true
}: MoveTimerProps) {
  const percentage = seconds / totalSeconds * 100;
  // Color logic
  let colorClass = 'text-emerald-500';
  if (seconds <= 10) colorClass = 'text-amber-500';
  if (seconds <= 5) colorClass = 'text-red-500';
  return <div className={cn('flex items-center gap-2 font-mono font-bold transition-colors', colorClass, seconds <= 5 && isActive && 'animate-pulse')} data-id="element-126">
      <div className="relative w-6 h-6" data-id="element-127">
        <svg className="w-full h-full -rotate-90" viewBox="0 0 36 36" data-id="element-128">
          <path className="text-slate-200" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" data-id="element-129" />
          <path className={cn('transition-all duration-1000 ease-linear', colorClass)} strokeDasharray={`${percentage}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" data-id="element-130" />
        </svg>
      </div>
      <span data-id="element-131">0:{seconds.toString().padStart(2, '0')}</span>
    </div>;
}